const CaseUserStatus = {
    CaseUser: 1,
    CaseViewer: 2,
    CaseApprover: 3
}

export default CaseUserStatus